module.exports = {
  menu: {
    gmBlockingThreshold: 'Seuil de Blocage GM',
    lockThePlace: 'Verrouille ta place',
  },
  home: {
    title: 'Ce site contient présentement 2 sections',
    describeGmBlockingThreshold: 'Cet outil permet de calculer combien de PF sont à ajouter sur votre GM pour que vous sécurisiez la P1 P2 P3 P4 et P5 à d\'autres joueurs en fonction de leur bonus Arche',
    describeLockThePlace: 'Cet outil permet de connaitre le nombre de PF à poser sur un GM pour verrouiller votre place ainsi qu\'en déduire le bilan (gain / perte) final',
  },
  gmBlockingThreshold: {
    info: {
      title: 'Infos',
      expand: '[clique pour afficher]',
      reduce: '[clique pour réduire]',
      describeColumns: 'Chaque colonne représente le nombre de PF à poser pour que la place que vous voulez offrir à un joueur soit sécurisée en prenant en compte le % de bonus de son Arche',
      describeRed: {
        unlockableStart: 'Cette couleur signifie que ',
        unlockableBold: 'vous ',
        unlockableEnd: 'devez poser x PF pour sécuriser la place au taux sélectionné. ',
        middle: 'Votre ami posera ensuite ',
        lockable: '(x PF)',
      },
      describeGreen: 'Cette couleur signifie que le joueur peut poser x PF et ainsi bloquer la place au taux sélectionné',
      describeClickOnLine: 'Cliquez sur une ligne pour la surligner',
      describeCopy: {
        beforeImg: 'Cliquez sur ',
        afterImg: 'pour copier un message de promotion du type ',
        promoteExample: 'Zeus (607) 👉 P4(10) P3(29) P2(95) P1(190)'
      }
    },
    select: 'Choisi un GM',
    th: {
      level: 'Niveau',
      maxFp: 'PF Max',
      p1: 'P1 à (%)',
      p2: 'P2 à (%)',
      p3: 'P3 à (%)',
      p4: 'P4 à (%)',
      p5: 'P5 à (%)',
      p1To5: {
        line1: 'PF pour',
        line2: 'sécu de',
        line3: 'P1 à P5'
      }
    },
    results: {
      unlockable: ' $value PF',
      lockable: 'Avec $value PF',
      tooltip: ' ($value PF)',
      total: '$value PF',
    },
    notification: {
      promotionMessage: 'Promotion niveau $level copié ! 🎉'
    }
  },
  lockThePlace: {
    maxPf: 'PF Maximum du GM',
    totalPfPut: 'Total PF posés sur le GM',
    pfToOvertake: 'Nb PF de la place à dépasser',
    pfToEarn: 'Gain de la place visée',
    yourArcBonus: 'Ton % gain avec bonus Arche (100-200%)',
    ownPfLaid: 'PF que tu as déjà posé(s)',
    label: 'Libellé (facultatif)',
    impossible: 'Impossible',
    win: '{plural($balanceSheet ,["gagné","gagnés"])}',
    lost: '{plural($balanceSheet ,["perdu","perdus"])}',
    neededToLock: 'Pour bloquer la place, poser : $toPut PF',
    balanceSheet: 'Bilan : $balanceSheet PF ',
  },
  contact: {
    title: 'Contact',
    content: 'Une suggestion ? un bug ? une remarque ? une demande d\'ajout de fonctionnalité ? Envoyez un courriel à ',
    curious: 'Curieux de découvrir qui se cache derrière ce site ? 🔍',
    portfolioLink: 'Découvrir'
  },
  gms: {
    Observatory: 'Observatoire',
    Temple_of_Relics: 'Temple des reliques',
    Oracle_of_Delphi: 'Oracle de Delphes',
    Galata_Tower: 'Tour de Galata',
    Tower_of_Babel: 'Tour de Babel',
    Statue_of_Zeus: 'Statue de Zeus',
    Colosseum: 'Colisée',
    Lighthouse_of_Alexandria: 'Phare d\'Alexandrie',
    Hagia_Sophia: 'Hagia Sophia',
    Cathedral_of_Aachen: 'Aix-la-Chapelle',
    St_Mark_s_Basilica: 'Basilique Saint-Marc',
    Notre_Dame: 'Notre-Dame',
    Saint_Basil_s_Cathedral: 'Saint-Basile',
    Castel_del_Monte: 'Castel del Monte',
    Deal_Castle: 'Château de Deal',
    Frauenkirche_of_Dresden: 'Frauenkirche de Dresde',
    Capitol: 'Capitole',
    Royal_Albert_Hall: 'Royal Albert Hall',
    Chateau_Frontenac: 'Château Frontenac',
    Alcatraz: 'Alcatraz',
    Space_Needle: 'Space Needle',
    Atomium: 'Atomium',
    Cape_Canaveral: 'Cap Canaveral',
    The_Habitat: 'L\'Habitat',
    Lotus_Temple: 'Temple du lotus',
    Innovation_Tower: 'Tour de l\'innovation',
    Truce_Tower: 'Tour de la trêve',
    Voyager_V1: 'Voyager V1',
    The_Arc: 'L\'arche',
    Rain_Forest_Project: 'Forêt tropicale',
    Gaea_Statue: 'Statue de Gaïa',
    Arctic_Orangery: 'Orangerie arctique',
    Seed_Vault: 'Chambre forte des graines',
    Atlantis_Museum: 'Musée de l\'Atlantide',
    The_Kraken: 'Le Kraken',
    The_Blue_Galaxy: 'La galaxie bleue',
    Terracotta_Army: 'Armée de terre cuite',
    Himeji_Castle: 'Château d\'Himeji',
    The_Virgo_Project: 'Le Projet Virgo',
    Star_Gazer: 'Star Gazer',
    Space_Carrier: 'Transporteur Spatial',
    Flying_Island: 'L\'île Volante',
    AI_Core: 'Noyau d\'I.A.',
    Saturn_VI_Gate_CENTAURUS: 'Saturne VI Porte Centaure',
    Saturn_VI_Gate_PEGASUS: 'Saturne VI Porte Pégase',
    Saturn_VI_Gate_HYDRA: 'Saturne VI Porte Hydre',
    Stellar_Warship: 'Vaisseau de guerre stellaire',
    Cosmic_Catalyst: 'Catalyseur cosmique',
  }
}



// WEBPACK FOOTER //
// ./src/locale/languages/fr.js